// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\CustomFieldWidgetResponse

import { CustomFieldWidgetRule, CustomFieldType } from './enums.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type CustomFieldWidgetApiResponse = {
	id: string;
	publicName: string;
	publicDescription: string;
	widgetRule: CustomFieldWidgetRule;
	visibleByCustomer: boolean;
	applyOnAllBookings: boolean;
	applyOnActivities: string[];
	applyOnOffers: string[];
	applyOnSessions: string[];
	applyMinPax: number | null;
	applyMaxPax: number | null;
	attachToCustomer: boolean;
	archivedAt: string | null;
	sortOrder: number;
	fieldType: CustomFieldType;
	fieldSettings: { content?: string | null; minLength?: number | null; maxLength?: number | null; regex?: string | null; textarea?: boolean | null; min?: number | null; max?: number | null; decimal?: boolean | null; options?: Array<string> | null; addExtraOption?: boolean | null; restrict?: string | null; display?: string | null; relativeMin?: number | null; relativeMax?: number | null };
};

export type CustomFieldWidget = {
	id: string;
	publicName: string;
	publicDescription: string;
	widgetRule: CustomFieldWidgetRule;
	visibleByCustomer: boolean;
	applyOnAllBookings: boolean;
	applyOnActivities: string[];
	applyOnOffers: string[];
	applyOnSessions: string[];
	applyMinPax: number | null;
	applyMaxPax: number | null;
	attachToCustomer: boolean;
	archivedAt: DateTime | null;
	sortOrder: number;
	fieldType: CustomFieldType;
	fieldSettings: { content?: string | null; minLength?: number | null; maxLength?: number | null; regex?: string | null; textarea?: boolean | null; min?: number | null; max?: number | null; decimal?: boolean | null; options?: Array<string> | null; addExtraOption?: boolean | null; restrict?: string | null; display?: string | null; relativeMin?: number | null; relativeMax?: number | null };
};

export function hydrateCustomFieldWidget(data: CustomFieldWidgetApiResponse): CustomFieldWidget {
	return {
		...data,
		archivedAt: DateTimefromISO(data.archivedAt),
	};
}